import { observable } from "mobx";
import CustomerRatingScore from "./customerRatingScore";
import { EntityValidationRules } from "services/validationService";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class ChargeOrderCustomerRatingRequest {
  @observable
  score!: CustomerRatingScore;

  @observable
  comment?: string;
}

export const ChargeOrderCustomerRatingRules: EntityValidationRules<ChargeOrderCustomerRatingRequest> = {
  score: {
    required: true,
  },
  comment: {
    isLength: {
      max: 1000,
      customMessage: "ratingCommentLenght",
    },
    prohibitedCharacters: true,
  },
};
